export interface FaqItem {
  question: string
  answer: string
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  return (
    <div className="space-y-4">
      {items.map((item, index) => (
        <details key={item.question} className="marketing-faq" open={index === 0}>
          <summary className="marketing-faq-summary">
            <span>{item.question}</span>
            <span className="marketing-faq-plus" aria-hidden="true">+</span>
          </summary>
          <p className="marketing-faq-body">{item.answer}</p>
        </details>
      ))}
    </div>
  )
}
